import React, { useEffect, useState } from "react";
import Stepper from "../../ui/Stepper";
import "../../../../assets/css/cms/Exam.css";
import { STEPPER_LIST_COACHING } from "../../../../constants/cms";
import TopperDetailsForm from "./topperDetailsForm";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getCmsCoachingCourseDropdownList,
  getCmsCoachingExams,
  getCmsCoachingToppers,
} from "../../../../../store/actions/cms/cmsCoaching";

const ToppersDetails = (props) => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(3);
  const { id } = useParams();
  const dispatch = useDispatch();
  const [initialValues, setInitialValues] = useState({
    topper_data: [{}],
  });
  const {
    coachingToppers,
    post_cms_coaching_topper_success,
    patchCmsCoachingTopper
  } = useSelector((state) => state?.cmsCoaching);

  let dropdownConstants = {};
  dropdownConstants.genderOptions = [
    { value: "Male", label: "male" },
    { value: "Female", label: "female" },
    { value: "Other", label: "other" },
  ];

  let currentDate = new Date();
  let years = [];
  for (
    let i = currentDate.getFullYear() - 10;
    i <= currentDate.getFullYear();
    i++
  ) {
    years.push({ id: i, label: i });
  }

  dropdownConstants.result_year_Options = years;

  const handleClick = (key, obj) => {
    setCurrentStep(key);
    if (obj.route) {
      if (id) {
        navigate(`/cms/coaching/${id}/${obj.route}`);
      } else {
        navigate(`/cms/coaching/${obj.route}`);
      }
    } else {
      navigate("/cms/coaching");
    }
  };

  useEffect(() => {
    if (post_cms_coaching_topper_success || patchCmsCoachingTopper) {
      dispatch(getCmsCoachingToppers({ coaching_id: id }));
      setTimeout(() => {
        dispatch({ type: "CLEAR_POST_CMS_COACHING_TOPPER" });
        dispatch({ type: "CLEAR_PATCH_CMS_COACHING_TOPPER" });
      }, 2000);
    }
  }, [post_cms_coaching_topper_success || patchCmsCoachingTopper])

  useEffect(() => {
    setTimeout(() => {
      dispatch({ type: "CLEAR_UPDATE_CMS_COACHING_MEDIA" });
    }, 2000);
  }, [coachingToppers]);

  useEffect(() => {
    let params = {}
    params.coaching_id = id;
    dispatch(getCmsCoachingToppers({ coaching_id: id }));
    dispatch(getCmsCoachingExams({ exam_name: "", ...params }));
    dispatch(getCmsCoachingCourseDropdownList({ course_name: "", ...params }));
  }, []);

  useEffect(() => {
    if (coachingToppers?.Data?.length > 0) {
      let newValues = [];
      coachingToppers?.Data?.forEach((element) => {
        let topper = {};
        topper.id = element?.id;
        topper.student_name = element?.name;
        topper.student_gender = dropdownConstants.genderOptions?.find(
          (obj) => obj?.value == element?.gender
        );
        if (element?.course_name && element?.course_id) {
          topper.course_name = {
            course_name: element?.course_name,
            course_id: element?.course_id,
          };
        }
        topper.exam = {
          exam_name: element?.exam_name,
          exam_id: element?.exam_id,
        };
        topper.result_type = coachingToppers?.Result_type?.find(
          (obj) => obj?.id == element?.result_type
        );
        topper.rank_type = coachingToppers?.Rank_type?.find(
          (obj) => obj?.id == element?.rank_type
        );
        topper.result_year = dropdownConstants.result_year_Options?.find(
          (obj) => obj?.label == element?.result_year
        );
        topper.result_value = element?.result_value;
        topper.image = element?.image;
        topper.updated_by_name = element?.updated_by_name;
        topper.updated_on = element?.updated_on;
        newValues.push(topper);
      });
      setInitialValues({
        topper_data: newValues,
      });
    }
  }, [coachingToppers]);

  return (
    <div>
      <div className={"mt50"}>
        <div className={`${"stepper"} ${"examviewlist"}`}>
          <Stepper
            data={STEPPER_LIST_COACHING}
            activeStep={currentStep}
            onClickChange={(obj, arr) => handleClick(obj, arr)}
          />
        </div>
      </div>
      <div>
        <TopperDetailsForm
          initialValues={initialValues}
          dropdownConstants={dropdownConstants}
        />
      </div>
    </div>
  );
};

export default ToppersDetails;
